import {
	FOUNDATION_EVENTS,
	type FoundationEventName,
} from "./foundation-events.js";
import { trackPlausible, type PlausibleProps } from "./plausible.js";

declare global {
	// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
	interface Window {
		fbq?: (action: string, event: string) => void;
		lintrk?: (action: "track", data: { conversion_id: number }) => void;
	}
}

/** Sends one tracked interaction to every vendor that declares it. */
export type Dispatch = (
	name: FoundationEventName,
	props?: PlausibleProps,
) => void;

/**
 * Builds the dispatcher. Properties reach Plausible only, since LinkedIn and
 * Meta take the fixed IDs declared in the event catalogue.
 *
 * @param baseProps Properties sent with every event.
 * @returns The dispatcher.
 */
export default function createDispatch(baseProps: PlausibleProps): Dispatch {
	return (name, props) => {
		const event = FOUNDATION_EVENTS[name];

		trackPlausible(event.plausible, { ...baseProps, ...props });

		if ("linkedInId" in event) {
			window.lintrk?.("track", { conversion_id: event.linkedInId });
		}

		if ("meta" in event) {
			window.fbq?.(event.meta.action, event.meta.event);
		}
	};
}
